<div class="flex align-items-center">
  @if (status().toLowerCase() === 'cold') {
    <div>
      <i class="fa-regular fa-snowflake text-blue-300 text-lg mr-2"></i>
    </div>
  }
  @if (status().toLowerCase() === 'warm') {
    <div>
      <i class="fa fa-temperature-empty text-orange-400 text-lg mr-2"></i>
    </div>
  }
  @if (status().toLowerCase() === 'hot') {
    <div>
      <i class="fa fa-fire p-error text-lg mr-2"></i>
    </div>
  }
  <span class="text-xs text-600 font-medium">{{ status() }}</span>
</div>
